<template>
	<div class="inner-page forms">


		<AppHead title="PMS Forms Management" />
		
		<PageHeader 
			title="PMS Forms Management"
			desc="Manage forms that are used in the Post Market Surveillance step of a case."
			:hasButton="true"
			buttonLabel="New Form"
			buttonRoute="/admin/pms-forms/new"
			:showHelper="true"
			helpTitle="How to use forms..."
			helpDesc="Forms are used in the Post Market Surveillance step of a case, each form is built from several smaller blocks of questions that show based on the conditions of the case. You can manage your forms and form blocks here. You can create a new form by clicking the “New Form” button above. You can manage taxonomies such as 'Anatomies' and 'Case Features' by clicking the “Manage Taxonomies” button."
			:backButton="false"
			:reverseRightBlock="true"
			>
			
			<Button
				label="Manage Taxonomies"
				size="regular"
				color="blue"
				icon="wrench"
				buttonRoute="/admin/pms-forms/taxonomies"
				/>

		</PageHeader>

		<TableForms 
			:forms="forms" 
			@addNewForm="addNewForm"
			@editForm="editForm"
			@editBlocks="editBlocks"
			/>


	
	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import { Link } from '@inertiajs/inertia-vue3'
import TableForms from "@/Components/TableForms"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Subtitle,
		Placeholder,
		Button,
		Link,
		TableForms
	},
	layout: AppLayout,
	props: {
		forms: [Array, Object]
	},
	data: () => {
		return {
			
		}
	},
	methods: {
		addNewForm(){
			this.$inertia.visit('/admin/pms-forms/new')
		},
		editForm(id){
			this.$inertia.visit(`/admin/pms-forms/${id}/edit`)
		},
		editBlocks(id){
			this.$inertia.visit(`/admin/pms-forms/${id}/blocks`)
		}
	},
	mounted(){
		
	}
};
</script>

<style lang="sass">

.forms

		

</style>